import * as React from 'react';
import { useParams } from 'react-router-dom';
import { SingleColumnLayout } from '../../../../../designSystem/layouts/SingleColumnLayout';
import { ProtectedPageWrapper } from '../../../../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { PageHeader } from '../../../../../designSystem/PageHeader';
import { Button } from '../../../../../designSystem/button/Button';
import { CustomFormAnswerSubmissionPanel } from '../../../_components/CustomFormAnswerSubmissionPanel';
import { customFormsVideoSubmissionEnabled, getCustomForm, getCustomFormAnswer } from '../../../../../api/customFormClientApi';
import { buildTranslator, CustomForm, CustomFormAnswer } from '../../../../../amorg-common';
import { getMaybeActiveUserOrRefresh } from '../../../../../api/serverApiHelpers';
import { LinkButton } from '../../../../../designSystem/button/LinkButton';
import { useReactToPrint } from 'react-to-print';
import { ToolBarButton, ToolBarContainer } from '../../../../../designSystem/compositeComponents/ButtonToolBar';
import { PrintCustomFormAnswerPage } from './PrintCustomFormAnswerPage';


export function CustomFormAnswerPage():JSX.Element
{
    const params = useParams<{formId:string, answerId:string}>();

    const [state, setState] = React.useState<{
        loading:boolean,
        selectedMenuItemKey:string,
        siteId:string,
        form:CustomForm
    }>({
        loading:true,
        selectedMenuItemKey:'',
        siteId:'',
        form:null
    });

    
    React.useEffect(()=>{
        const getData = async ()=>{
            const user = await getMaybeActiveUserOrRefresh(['ViewCustomFormAnswerList']);
            const form = await getCustomForm(params.formId);
            setState({form, siteId:user.tokenUser.siteId, selectedMenuItemKey:form.category, loading:false});
        };
        getData();
    }, [params.formId, params.answerId]);

    const [isLocked, setIsLocked] = React.useState(true);
    const [inPrint, setInPrint] = React.useState(false);

    const [printState, setPrintState] = React.useState<{answer:CustomFormAnswer, videoSubmissionEnabled:boolean}>(null);

    const translator = buildTranslator('da');

    const printRef = React.useRef(null);
    const printFn = useReactToPrint({
        
        contentRef: printRef,
        documentTitle: state.form ? translator(state.form.name) : '',
        onAfterPrint: () => setInPrint(false)
    });

    async function handlePrint(){
        const answer = await getCustomFormAnswer(params.answerId, state.siteId);
        const videoSubmissionEnabled = await customFormsVideoSubmissionEnabled(state.siteId);
        setPrintState({ answer, videoSubmissionEnabled });
        setInPrint(true);
        printFn();
    }

    return (
        
        <ProtectedPageWrapper requiredPermissions={['ViewCustomFormAnswerList']} selectedMenuItemKey={state.selectedMenuItemKey}>
            <SingleColumnLayout  
                noDivider
                contentContainer={
                    <>

                    <PageHeader 
                        headerText="Formular" 
                        headerStyle="secondary-gray"
                        // breadCrumbs={[{ text:'Tilbage til oversigten', url:`/customForms/${params.formId}/answers`}]} 
                        buttons={
                        
                        <ToolBarContainer>
                            {isLocked && 'Lås op'}
                            <Button 
                                icon={isLocked ? 'lock' : 'lock_open'}
                                toolTipText={isLocked ? 'Lås skema op' : 'Lås skema'}
                                onClick={() => setIsLocked(!isLocked)} 
                                variant={isLocked ? 'destructive-text' : 'text'} />

                            <ToolBarButton
                                icon='interface_actions_print'
                                tooltip='Print'
                                variant='text'
                                onClick={handlePrint}
                                />

                        </ToolBarContainer> }
                        />

                    {state.form && inPrint &&
                        <PrintCustomFormAnswerPage
                            form={state.form}
                            siteId={state.siteId}
                            answer={printState.answer}
                            videoSubmissionEnabled={printState.videoSubmissionEnabled}
                            innerRef={printRef} />        
                    }


                    <div>
                        <LinkButton href={`/customForms/${state.form?.activityId || ''}`} icon='arrow_back' variant='outlined' text='Tilbage til oversigten' />
                    </div>

                    {state.form &&
                        <CustomFormAnswerSubmissionPanel siteId={state.siteId} form={state.form} answerId={params.answerId} disableAnswerComponents={isLocked} />
                    }
                    </>
                } />
            
        </ProtectedPageWrapper>
    );
}